import { render } from "./SignUpSucceeded.vue?vue&type=template&id=21d936dc"
import script from "./SignUpSucceeded.vue?vue&type=script&lang=js"
export * from "./SignUpSucceeded.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__